<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">{{total}} Purchases</h4>
                                <h5 class="card-subtitle">List of purchases available in your marketplace.</h5>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'addexpresspurchase', params: {expressid: currentOrg.express_id}}" class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New PO
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-4">
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="suppliers"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchSuppliers"
                                            class="form-control"
                                            id="customer"
                                            label="Search Customer"
                                            name="customer"
                                            open-direction="bottom"
                                            placeholder="Customer"
                                            v-model="filter.seller">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Purchaser not found</span>
                                    </multiselect>
                                </div>
                                <div class="form-group col-md-2">
                                    <select class="custom-select form-control" id="inlineFormCustomSelect" style="height: 42px;" v-model="filter.status">
                                        <option :value="null">Choose Status</option>
                                        <option v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">
                                            {{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <input class="form-control"
                                           name="purchase"
                                           placeholder="PO/Contract"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="filter.number">
                                </div>
                                <div class="form-group col-md-4">
                                    <div class="input-group" id="drp">
                                        <v-md-date-range-picker
                                                :auto-apply="false"
                                                :end-date="endDate"
                                                :opens="opens"
                                                :show-activator-bar="false"
                                                :show-activator-label="false"
                                                :show-custom-range-label="value"
                                                :start-date="startDate"
                                                @change="change"
                                                show-year-select>
                                        </v-md-date-range-picker>
                                        <div class="input-group-append">
                                            <button @click="getPurchases(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                                <i class="fa fa-search"/> Go!
                                            </button>
                                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"  type="button">
                                                <i class="fa fa-undo"/> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="table-responsive m-t-30"  v-if="purchases.length>0">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-sm-1 p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length" v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>

                                    <div class="ml-auto">
                                        <span class="fa-xs fa-stack fa-1x ml-auto m-r-10 text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <div class="btn-group">
                                            <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info dropdown-toggle" data-toggle="dropdown"
                                                    type="button">
                                                Operations
                                            </button>
                                            <div class="dropdown-menu">
                                                <a @click="poCheckout(checkedPos)" class="dropdown-item" href="javascript:void(0)">
                                                    Checkout
                                                </a>
                                                <div class="dropdown-divider" v-if="currentOrg.type === 'COOP'"></div>
                                                <!--                                            <div class="dropdown-divider"></div>-->
                                                <a @click="exportPosAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                    <i class="fa fa-file-excel"/> Export
                                                </a>
                                                <a @click="printPdf()" class="dropdown-item" href="javascript:void(0)">
                                                    <i class="fa fa-print"/> Print
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="table no-wrap v-middle" v-if="purchases.length>0">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0" style="width: 0px;">
                                        <div class="form-check">
                                            <input
                                                    @change="checkAll($event)"
                                                    class="form-check-input"
                                                    id="checkAll"
                                                    type="checkbox">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>
                                    <th class="border-0"><h6>#</h6></th>
                                    <th class="border-0"><h6>Status</h6></th>
                                    <th class="border-0"><h6>PO No</h6></th>
                                    <th class="border-0"><h6>Contract No</h6></th>
                                    <th class="border-0"><h6>Supplier</h6></th>
                                    <!--<th class="border-0"><h6>Transaction</h6></th>-->
                                    <!--<th class="border-0"><h6>Contract</h6></th>-->
                                    <th class="border-0"><h6>Amount</h6></th>
                                    <th class="border-0"><h6>Created At</h6></th>
                                    <th class="border-0"><h6>Actions</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(p, index) in purchases">
                                    <td class="sorting_1">
                                        <div class="form-check">
                                            <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    v-bind:id="p.id"
                                                    v-bind:value="p"
                                                    v-model="checkedPos">
                                            <label class="form-check-label" v-bind:for="p.id"></label>
                                        </div>
                                    </td>
                                    <td>{{pageCount+index}}</td>
                                    <td>
                                        <dd class="mb-1">
                                            <p v-if="p.status === 'DRAFT'"><span class="label label-megna">Draft</span></p>
                                            <p v-if="p.status === 'CONFIRMED'"><span class="label label-light-green">Confirmed</span></p>
                                            <p v-if="p.status === 'RECEIVED'"><span class="label label-dark-green">Received</span></p>
                                            <p v-if="p.status === 'VOID'"><span class="label label-grey">Void</span></p>
                                        </dd>
                                    </td>
                                    <td>{{p.number}}</td>
                                    <td>{{p.contract_number||'N/A'}}</td>
                                    <td>{{p.seller.biz_name | capitalize}}</td>
                                    <td>{{ { amount : p.total, ...p.currency } | money}}</td>
                                    <td>{{p.created_at | medium}}</td>
                                    <td>
                                        <router-link :to="{name: 'viewexpresspurchase', params: {poid: p.id}}">
                                            <h6>View</h6>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="hide table-responsive" id="po-summary-table">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Purchase Order Number</th>
                                        <th>Status</th>
                                        <th>Supplier Name</th>
                                        <th>Buyer Name</th>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Rate</th>
                                        <th>Price</th>
                                        <th>Created at</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-bind:key="index" v-for="(cp, index) in checkedPos">
                                        <td>{{index+1}}</td>
                                        <td>{{cp.number}}</td>
                                        <td>{{cp.status}}</td>
                                        <td>{{cp.seller.biz_name}}</td>
                                        <td>{{cp.buyer.biz_name}}</td>
                                        <td>{{cp.name}}</td>
                                        <td>{{cp.quantity | units}}</td>
                                        <td>{{cp.rate | money}}/{{cp.quantity.unitSymbol}}</td>
                                        <td>{{cp.total | money}}</td>
                                        <td>{{cp.created_at | timestamp}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="purchases.length>0">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import _ from 'lodash';
    import JsonCSV from 'vue-json-csv';
    import XLSX from 'xlsx';

    export default {
        name: "Purchases",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate, Multiselect, JsonCSV},
        data() {
            return {
                statuses: ['DRAFT', 'CONFIRMED', 'RECEIVED', 'VOID'],
                $BORLAUG: this.$BORLAUG,
                suppliers: [],
                buyers: [],
                filter: {
                    seller: null,
                    status: null,
                    fromDate: null,
                    toDate: null,
                    number: null
                },
                isFiltered: false,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                purchases: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                checkedPos: [],
                exportedPos: [],
                pos_export_name: "Purchase_Report.csv",
                perPage: 10,
                exporting: false
            };
        },
        watch: {
            checkedPos: function(val) {
                let cnt          = 0;
                this.exportedPos = [];
                val.forEach(cpo => {
                    let obj = {
                        '#': cnt + 1,
                        'Purchase Order Number': cpo.number,
                        'Status': cpo.status,
                        'Supplier Name': cpo.seller.biz_name,
                        'Buyer Name': cpo.buyer.biz_name,
                        'Product': cpo.name,
                        'Quantity': cpo.quantity.amount + cpo.quantity.unitSymbol,
                        'Rate': `${cpo.rate.currency_symbol}${cpo.rate.amount}/${cpo.quantity.unitSymbol}`,
                        'Price': cpo.total.currency_symbol + cpo.total.amount,
                        'Created at': moment(Date.parse(cpo.created_at)).format("MMMM Do YYYY, h:mm:ss a")
                    };
                    this.exportedPos.push(obj);
                    cnt++;
                })
            }
        },
        mounted() {
            this.getPurchases(1);
        },
        methods: {
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate   = e[1].toDate();
            },
            async getPurchases(page) {
                try {
                    let filter = {
                        seller: this.filter.seller ? this.filter.seller.id : null,
                        status: this.filter.status,
                        fromDate: this.filter.fromDate,
                        toDate: this.filter.toDate,
                        number: this.filter.number
                    }
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/purchases`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            ...filter
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total     = reply.data.total;
                    this.purchases = reply.data.purchases;
                    let max_date   = reply.data.min_date;
                    let min_date   = reply.data.max_date;
                    if(min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate   = moment(min_date).format('YYYY-MM-DD');
                    } else if(this.purchases.length === 1) {
                        this.startDate = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                        this.endDate   = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate   = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = false;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.error(e);
                }
            },
            pageHandler(pageNum) {
                this.getPurchases(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            viewPurchaseOrder(poid) {
                this.$router.push({name: "viewpo", params: {poid: poid}});
            },
            viewTx(tx) {
                console.log(tx);
            },
            viewContract(contract) {
                console.log(contract);
            },
            async searchSuppliers(searchText) {
                try {
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.suppliers = reply.data;
                } catch(e) {
                    console.log(e);
                }
            },
            async reset() {
                this.filter.seller   = null;
                this.filter.status   = null;
                this.filter.fromDate = null;
                this.filter.toDate   = null;
                this.filter.number   = null;
                await this.getPurchases(1);
            },
            poCheckout(checkedPos) {
                if(this.checkedPos.length === 0) {
                    this.$toastr('warning', 'Choose at least one Purchase order to perform the operation', 'Warning');
                    return;
                }
                let supplier = _.uniqBy(checkedPos, 'supplier.id');
                let paidPos  = _.filter(checkedPos, {
                    status: 'PAID'
                });
                if(supplier.length !== 1) {
                    this.$toastr('error', 'You cant checkout with different supplier simultaneously', 'Failed');
                } else if(paidPos.length > 0) {
                    this.$toastr('error', 'Contain paid purchase order', 'Failed');
                } else {
                    this.$router.push({name: 'expresspocheckout', params: {checkedPos}});
                }
            },
            checkAll(e) {
                if(e.target.checked) {
                    this.checkedPos = this.purchases
                } else {
                    this.checkedPos = []
                }
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.searchPo(1);
                } else {
                    this.getPurchases(1);
                }
            },
            exportPos() {
                if(this.checkedPos.length === 0) {
                    this.$toastr('warning', 'Choose at least one Purchase order to perform the operation', 'Warning');
                }
            },
            printPdf() {
                if(this.checkedPos.length === 0) {
                    this.$toastr('warning', 'Choose at least one Purchase order to perform the operation', 'Warning');
                    return;
                }
                this.$htmlToPaper('po-summary-table');
            },
            async exportPosAsExcel() {
                try {
                    this.exporting = true;
                    let filter     = {
                        seller: this.filter.seller ? this.filter.seller.id : null,
                        status: this.filter.status,
                        fromDate: this.filter.fromDate,
                        toDate: this.filter.toDate,
                        number: this.filter.number
                    }
                    let reply      = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            ...filter
                        }
                    });
                    let data       = reply.data.purchases;
                    let purchases  = [];
                    data.forEach(d => {
                        purchases.push({
                            "ID": d.id,
                            "Number": d.number,
                            "Contract Number": d.contract_number,
                            "Status": d.status,
                            "Created At": moment(d.created_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                            "Seller Name": d.seller.name,
                            "Seller Biz Name": d.seller.biz_name,
                            "Total": Number(d.total).toFixed(2),
                            "Currency Symbol": d.currency.currency_symbol,
                            "Currency Name": d.currency.currency_name
                        })
                    });

                    let workbook   = XLSX.utils.book_new();
                    let worksheet  = XLSX.utils.json_to_sheet(purchases);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Purchases');
                    XLSX.writeFile(workbook, 'purchases.xlsx');
                } catch(e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
